<template src="./gestionRehabilitacion.html">
    
</template>
<script>
export default {
    data() {
        return {
            banderaVerGraficaAuxiliar:false
        }
    },
    methods: {
        verGrafica(){
            this.$router.push({ name: 'graficaRhb', params: {graficaRhbId:1}})
        },
        verMensaje(){
            this.$router.push({ name: 'envioMensaje'})
        }
    },
}
</script>
<style src="./gestionRehabilitacion.scss" lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Gestion/gestionRehabilitacion/gestionRehabilitacion.vue